import { defineComponent as _defineComponent } from 'vue'
import { ref, Ref, watch, onMounted, onBeforeUnmount } from 'vue';
import { ICON_NAME } from '../../../../constants/icon';
import IconButton from '../../common/IconButton.vue';
import SvgIcon from '../../common/SvgIcon.vue';
import TUIRoomCore, { ETUIRoomEvents, ETUISignalStatus, ETUIRoomRole } from '../../../tui-room-core';
import { Message } from 'element-ui';
import { MESSAGE_DURATION } from '../../../../constants/message';
import { useBasicStore } from '../../../../stores/basic';
import { useRoomStore } from '../../../../stores/room';
import {USER_ROLE_MAJOR, USER_ROLE_STARTV} from "@/constants/localKeys";
import {LIVE_STAGE} from "@/constants/room";
import { storeToRefs } from 'pinia';
import StringUtils from "@/putils/StringUtils";
import {LAYOUT} from "@/constants/render";
import logger from "@/TUIRoom/tui-room-core/common/logger/logs";

enum STATE {
  OffSeat = 'offSeat',
  OnSeat = 'onSeat',
  Applying = 'applying',
}
export default /*#__PURE__*/_defineComponent({
  __name: 'MemberApplyControl',
  setup(__props) {

const basicStore = useBasicStore();
const roomStore = useRoomStore();
const { layout, shareUserId,shareUserSig, userRole,screenProfile } = storeToRefs(basicStore);

;

const userState: Ref<STATE> = ref(STATE.OffSeat);
const showMemberApplyAttention: Ref<boolean> = ref(true);
const iconName: Ref<string> = ref('');
const iconTitle: Ref<string> = ref('');
const showInviteDialog: Ref<Boolean> = ref(false);

watch(userState, (val) => {
  if (val === STATE.OffSeat) {
    iconName.value = ICON_NAME.ApplyOnSeat;
    iconTitle.value = '举手';
  }
  if (userState.value === STATE.Applying) {
    iconName.value = ICON_NAME.ApplyActive;
    iconTitle.value = '手放下';
  }
  if (userState.value === STATE.OnSeat) {
    iconName.value = ICON_NAME.GoOffSeat;
    iconTitle.value = '下播';
  }
}, { immediate: true });


async function toggleApplySpeech() {
  hideApplyAttention();
  switch (userState.value) {
    case STATE.OffSeat:
      sendSeatApplication();
      break;
    case STATE.Applying:
      cancelSeatApplication();
      break;
    case STATE.OnSeat:
      leaveSeat();
      break;
    default:
      break;
  }
};

// 发送上麦申请
async function sendSeatApplication() {
  userState.value = STATE.Applying;
  try {
    const applyResponse = await TUIRoomCore.sendSpeechApplication();
    switch (applyResponse.code) {
      case ETUISignalStatus.ACCEPTED:
        handleApplyAccepted();
        break;
      case ETUISignalStatus.REJECTED:
        handleApplyRejected();
        break;
      case ETUISignalStatus.CANCELLED:
        break;
      default:
        break;
    }
  } catch (error) {
    console.log('member sendSpeechApplication error', error);
  }
}

// 取消上麦申请
async function cancelSeatApplication() {
  // 取消上麦申请
  try {
    await TUIRoomCore.cancelSpeechApplication();
    userState.value = STATE.OffSeat;
  } catch (error) {
    console.log('member cancelSpeechApplication', error);
  }
}

// 用户下麦
async function leaveSeat() {
  await TUIRoomCore.sendOffSpeaker();
  console.log("用户点击下麦---------------------------------")
  userState.value = STATE.OffSeat;
  basicStore.setRole(ETUIRoomRole.AUDIENCE);
  roomStore.setIsLocalAudioMuted(true);
  roomStore.setIsLocalVideoMuted(true);
  roomStore.setGrantAnchor(false);
  roomStore.updateLocalStream({
    isAudioStreamAvailable: false,
    isVideoStreamAvailable: false,
  });
  roomStore.setHasStartedMicrophone(false);
}

// 处理主持人接受申请
async function handleApplyAccepted() {
  userState.value = STATE.OnSeat;
  console.log("-------------userState-----处理主持人接受申请----------------")
  basicStore.setRole(ETUIRoomRole.ANCHOR);
  basicStore.setLiveStageRoom(LIVE_STAGE.ONGOING)
  console.log(basicStore)
  Message({
    type: 'success',
    message: '主持人同意了你的上台申请',
    duration: MESSAGE_DURATION.NORMAL,
  });
  //上麦成功
  // await TUIRoomCore.stopPublishing();
}

// 处理主持人拒绝申请
function handleApplyRejected() {
  userState.value = STATE.OffSeat;
  Message({
    type: 'warning',
    message: '主持人拒绝了你的上台申请',
    duration: MESSAGE_DURATION.NORMAL,
  });
}

function hideApplyAttention() {
  showMemberApplyAttention.value = false;
}

function onReceiveSpeechInvitation() {
  // 收到主持人邀请上麦
  console.log("---------------收到主持人邀请上麦-----------------------")
  showInviteDialog.value = true;
}

function onReceiveInvitationCancelled() {
  // 主持人取消邀请上麦
  showInviteDialog.value = false;
}

function onUserKickOffStage() {
  Message({
    type: 'warning',
    message: '您已被主持人邀请下线，需要发言请先举手',
    duration: MESSAGE_DURATION.NORMAL,
  });
  // 被主持踢下麦
  leaveSeat();
}

/**
 * 撤销主讲人操作
 * @param event
 */
async function onGrantAnchor(event:any) {
  if (event.mute){
    Message({
      type: 'success',
      message: '主持人已将您设为主讲人，请开始授课',
      duration: MESSAGE_DURATION.NORMAL,
    });

  }else{
    Message({
      type: 'warning',
      message: '主持人已收回您的主讲人权限',
      duration: MESSAGE_DURATION.NORMAL,
    });
    try {
      await TUIRoomCore.stopScreenShare({
        shareUserId: shareUserId.value,
        shareUserSig: shareUserSig?.value || '',
        screenProfile: screenProfile,
      });

      if (!StringUtils.isObjEqual(userRole,USER_ROLE_MAJOR)) {
        basicStore.setLayout(LAYOUT.TOP_SIDE_LIST);
      }
    } catch (error) {
      logger.error(`撤销播放 停止分享 error:`, error);
    }
    basicStore.setSharingStatus(false);
    roomStore.setRemoteScreenStream({userId:shareUserId.value,available:false})
  }
  roomStore.setGrantAnchor(event.mute);
}

// 用户接受/拒绝主讲人的邀请
function handleInvite(agree: boolean) {
  TUIRoomCore.replySpeechInvitation(agree);
  showInviteDialog.value = false;
  if (agree) {
    userState.value = STATE.OnSeat;
    basicStore.setRole(ETUIRoomRole.ANCHOR);
  }
}

// 用户进入 trtc 房间
function onUserAVEnabled(userInfo: { userId: string }) {
  const { userId } = userInfo;
  // 主播重新进入 trtc 房间，如果之前发送过请求上麦信令需要重新发送上麦申请
  if (userId === basicStore.masterUserId && userState.value === STATE.Applying) {
    sendSeatApplication();
  }
}

// 用户离开 trtc 房间
function onUserAVDisabled(userInfo: { userId: string }) {
  const { userId } = userInfo;
  // 主播离开 trtc 房间，如果正在进行上麦邀请，则不显示邀请框
  if (userId === basicStore.masterUserId && showInviteDialog.value) {
    showInviteDialog.value = false;
  }
}

onMounted(() => {
  TUIRoomCore.on(ETUIRoomEvents.onReceiveSpeechInvitation, onReceiveSpeechInvitation);
  TUIRoomCore.on(ETUIRoomEvents.onReceiveInvitationCancelled, onReceiveInvitationCancelled);
  TUIRoomCore.on(ETUIRoomEvents.onUserKickOffStage, onUserKickOffStage);
  TUIRoomCore.on(ETUIRoomEvents.onGrantAnchor, onGrantAnchor);
  TUIRoomCore.on(ETUIRoomEvents.onUserAVEnabled, onUserAVEnabled);
  TUIRoomCore.on(ETUIRoomEvents.onUserAVDisabled, onUserAVDisabled);
  //主播进入直播间 默认发起上麦申请：
  if (userRole.value == USER_ROLE_STARTV){
    // toggleApplySpeech();
  }
});

onBeforeUnmount(() => {
  TUIRoomCore.off(ETUIRoomEvents.onReceiveSpeechInvitation, onReceiveSpeechInvitation);
  TUIRoomCore.off(ETUIRoomEvents.onReceiveInvitationCancelled, onReceiveInvitationCancelled);
  TUIRoomCore.off(ETUIRoomEvents.onUserKickOffStage, onUserKickOffStage);
  TUIRoomCore.off(ETUIRoomEvents.onGrantAnchor, onGrantAnchor);
  TUIRoomCore.off(ETUIRoomEvents.onUserAVEnabled, onUserAVEnabled);
  TUIRoomCore.off(ETUIRoomEvents.onUserAVDisabled, onUserAVDisabled);
});


return { __sfc: true,basicStore, roomStore, layout, shareUserId, shareUserSig, userRole, screenProfile, STATE, userState, showMemberApplyAttention, iconName, iconTitle, showInviteDialog, toggleApplySpeech, sendSeatApplication, cancelSeatApplication, leaveSeat, handleApplyAccepted, handleApplyRejected, hideApplyAttention, onReceiveSpeechInvitation, onReceiveInvitationCancelled, onUserKickOffStage, onGrantAnchor, handleInvite, onUserAVEnabled, onUserAVDisabled, IconButton, SvgIcon }
}

})